import {
  mdiReceipt,
  mdiBroadcast,
  mdiFileDocumentOutline,
  mdiCurrencyUsd,
  mdiPen,
  mdiViewDashboardOutline,
  mdiDnsOutline,
  mdiLaptop,
  mdiCardMinus,
  mdiTooltipEditOutline,
  mdiCarOutline,
  mdiClockAlertOutline,
  mdiAccountBox,
  mdiStarOutline,
  mdiCalendar,
  mdiCellphone,
} from '@mdi/js'

export default [
  {
    title: 'Requests',
    icon: mdiTooltipEditOutline,
    to: { name: 'apps-request-list' },
    resource: 'Request',
    action: 'read',
    badge: true,
    badgeColor: 'error',
    show: ['Auditor'],
  },
  {
    title: 'Dashboard',
    icon: mdiViewDashboardOutline,
    to: { name: 'dashboard' },
    resource: 'Dashboard',
    action: 'read',
  },
  {
    title: 'Dashboard',
    icon: mdiViewDashboardOutline,
    to: { name: 'account-dashboard' },
    resource: 'ProfileDashboard',
    action: 'read',
  },
  {
    title: 'Logs',
    icon: mdiBroadcast,
    to: { name: 'apps-log-list' },
    resource: 'Logs',
    action: 'read',
  },
  {
    title: 'Calendar',
    icon: mdiCalendar,
    to: { name: 'apps-calendar' },
    resource: 'Event',
    action: 'read',
    badge: true,
    badgeColor: 'error',
    show: ['SPD reporter', 'Clerk', 'Auditor', 'Secretary'],
  },
  {
    title: 'Leads',
    icon: mdiCellphone,
    to: { name: 'apps-lead-list' },
    resource: 'Lead',
    action: 'read',
    children: [
      {
        title: 'New leads',
        to: { name: 'apps-new-lead-list' },
        resource: 'Lead',
        action: 'read',
        lead_access: true,
        badge: true,
        badgeColor: 'error',
        show: ['Clerk', 'SPD reporter'],
      },
      {
        title: 'Quoted leads',
        to: { name: 'apps-quoted-lead-list' },
        resource: 'Lead',
        action: 'read',
        quotation_access: true,
        badge: true,
        badgeColor: 'error',
        show: ['Clerk', 'SPD reporter', 'Part timer'],
      },
      {
        title: 'Issue leads',
        to: { name: 'apps-issue-lead-list' },
        resource: 'IssueLeadList',
        action: 'read',
        issue_receipt: true,
        badge: true,
        badgeColor: 'error',
        show: ['Clerk', 'SPD reporter'],
      },
      {
        title: 'Draft leads',
        to: { name: 'apps-attach-policy-list' },
        resource: 'IssueLeadList',
        action: 'read',
        issue_receipt: true,
        badge: true,
        badgeColor: 'error',
        show: ['Clerk', 'SPD reporter'],
      },
    ],
  },
  {
    title: 'Receipts',
    icon: mdiReceipt,
    to: { name: 'apps-receipt-list' },
    resource: 'Receipt',
    action: 'read',
  },
  {
    title: 'SPD Reporting',
    icon: mdiPen,
    to: { name: 'apps-spd-list' },
    resource: 'SpdReport',
    action: 'read',
    badge: true,
    badgeColor: 'error',
    show: ['SPD reporter', 'Support Staff', 'Secretary'],
  },
  {
    title: 'Invoices',
    icon: mdiFileDocumentOutline,
    to: { name: 'apps-invoice-list' },
    resource: 'Invoice',
    action: 'read',
  },
  {
    title: 'Corporate Quotation',
    icon: mdiCurrencyUsd,
    to: { name: 'apps-quotation-list' },
    resource: 'Quotation',
    action: 'read',
  },
  {
    title: 'Runner',
    icon: mdiCarOutline,
    to: { name: 'apps-runner-list' },
    resource: 'Runner',
    action: 'read',
  },
  {
    title: 'Reviews',
    icon: mdiStarOutline,
    to: { name: 'apps-review-list' },
    resource: 'ReviewList',
    action: 'read',
  },
  {
    title: 'Reminder',
    icon: mdiClockAlertOutline,
    to: { name: 'apps-reminder-list' },
    resource: 'Reminder',
    action: 'read',
  },
  {
    title: 'Profile Creation',
    icon: mdiAccountBox,
    to: { name: 'apps-profile-creation-list' },
    resource: 'ProfileCreation',
    action: 'read',
  },
  {
    title: 'Commissions',
    icon: mdiCurrencyUsd,
    to: { name: 'apps-commission-list' },
    resource: 'CommissionStats',
    action: 'read',
  },
  {
    title: 'Vouchers',
    icon: mdiCardMinus,
    to: { name: 'apps-voucher-list' },
    resource: 'Voucher',
    action: 'read',
  },
  {
    title: 'Website',
    icon: mdiLaptop,
    resource: 'Website',
    action: 'read',
    children: [
      {
        title: 'Promotions',
        to: { name: 'apps-banner-list' },
        resource: 'Website',
        action: 'read',
      },
    ],
  },
  {
    title: 'Loyalty',
    icon: mdiAccountBox,
    to: { name: 'apps-loyalty-list' },
    resource: 'LoyaltyList',
    action: 'read',
  },
  {
    title: 'Admin',
    icon: mdiDnsOutline,
    to: { name: 'admin-user-list' },
    resource: 'Admin',
    action: 'read',
  },
]
